'use es6';

import { useParams } from 'react-router-dom';
import AsyncRevenue from '../containers/revenue/AsyncRevenue';
import TemplateNotFound from '../containers/TemplateNotFound';
import { REVENUE_SUB_APP } from '../../constants/templates';
import { jsx as _jsx } from "react/jsx-runtime";
const AnalyticsToolsComponent = () => {
  const {
    templateId
  } = useParams();
  switch (templateId) {
    case REVENUE_SUB_APP:
      return /*#__PURE__*/_jsx(AsyncRevenue, {});
    default:
      return /*#__PURE__*/_jsx(TemplateNotFound, {});
  }
};
export default AnalyticsToolsComponent;